import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage } from "@fortawesome/free-regular-svg-icons";
import { faVideo } from "@fortawesome/free-solid-svg-icons";
import LuciPropTypes from "../../propTypes";
import {
  Table,
  TableBody,
  TableRow,
  TableHeader,
  TableCell,
  TableHeaderCell
} from "../../styled-components/Table";

const HeaderCell = styled(TableHeaderCell)`
  padding: 0.1rem 0.2rem;
  width: 50%;
`;

const CellBody = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
`;

const TableData = styled(TableCell)`
  padding: 0.1rem 0.2rem;
  width: 50%;
`;

class StoryItemDataFieldsView extends Component {
  renderItem = dataField => {
    const isImage = dataField.type === "Image" || dataField.type === "Texture";
    const isMovie = dataField.type === "Video";
    return (
      <TableRow key={dataField.type + dataField.index}>
        <TableData>
          <CellBody>
            <div>{dataField.viewMoniker}</div>
            {isImage ? (
              <FontAwesomeIcon fixedWidth size="lg" icon={faImage} />
            ) : (
              ""
            )}
            {isMovie ? (
              <FontAwesomeIcon fixedWidth size="lg" icon={faVideo} />
            ) : (
              ""
            )}
          </CellBody>
        </TableData>
        <TableData>{isImage ? dataField.fileName : dataField.data}</TableData>
      </TableRow>
    );
  };

  render() {
    return (
      <Table>
        <TableHeader>
          <TableRow>
            <HeaderCell colSpan="2">{this.props.title}</HeaderCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {this.props.dataFields.map(d => this.renderItem(d))}
        </TableBody>
      </Table>
    );
  }
}

StoryItemDataFieldsView.defaultProps = {
  dataFields: [],
  title: null
};

StoryItemDataFieldsView.propTypes = {
  dataFields: PropTypes.arrayOf(LuciPropTypes.DataFields),
  title: PropTypes.string
};

export default StoryItemDataFieldsView;



// WEBPACK FOOTER //
// ./app/components/RunningOrders/StoryItemDataFieldsView.js